package team.platforma.aicombo.activity.auth

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.app_name
import aicombo.composeapp.generated.resources.eye
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarColors
import androidx.compose.ui.Alignment
import androidx.compose.ui.graphics.Color
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import team.platforma.aicombo.activity.auth.component.AuthComponent
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.extra_nav.component.activity_component.Activity
import team.platforma.extra_nav.component.activity_component.ActivityScaffold
import team.platforma.multiplatform_material_extension.toolbar.Toolbar

@OptIn(ExperimentalMaterial3Api::class)
object AuthActivity : Activity(
    route = "auth_activity",
    components = listOf(AuthComponent),
    activityScaffold = { components ->
        ActivityScaffold(
            components = components,
            topBar = {
                Toolbar(
                    title = {
                        Row(
                            horizontalArrangement = Arrangement.Center,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(
                                painter = painterResource(Res.drawable.eye),
                                contentDescription = null
                            )
                            Text(
                                text = stringResource(Res.string.app_name),
                                style = Typography.text2xl(
                                    FontWeights.Medium
                                )
                            )
                        }
                    },
                    colors = TopAppBarColors(
                        containerColor = AppColors.bg.default().default,
                        scrolledContainerColor = Color.Transparent,
                        navigationIconContentColor = Color.Black,
                        titleContentColor = AppColors.text().default,
                        actionIconContentColor = Color.Black
                    )
                )

            }
        )
    }
)